module.exports = __webpack_public_path__ + "img/home.02359edd.png";